<template>
  <div class="enter-activate-container">
    <SimonModal
      :is-visible="showModal"
      @hide="showModal = false"
      id="activate-modal"
      show-footer-buttons
      :btn-left-title="modalCancelTitle"
      :btn-right-title="modalOkTitle"
      @btnRight="activateSubstituteSim"
      @btnLeft="showModal = false"
    >
      <template v-slot:modalTitle>
        <slot name="headerModal"></slot>
      </template>
      <slot name="contentModal"></slot>
    </SimonModal>
    <button class="filled yellow" :disabled="disabled" @click="enterActivateProcess">
      <slot name="btn"></slot>
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import beErrors from '@/mixins/beErrors'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ActivateBtn',
  components: { SimonModal },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    ...mapActions('substituteSimCard', [
      'activateSim'
    ]),
    enterActivateProcess: function () {
      this.showModal = true
    },
    activateSubstituteSim: function () {
      const comp = this
      this.startLoader()

      this.activateSim()
        .then((result) => {
          if (result) {
            comp.$emit('show-success')
          } else {
            comp.openErrorToast(comp.beErrorGetLastMessage())
          }
        })
        .catch((error) => {
          console.error('Error activating SIM:', error)
        })
        .finally(() => {
          this.stopLoader()
        })
    },
    openErrorToast: function () {
      this.errorToast(this.errorMessage())
    },
    errorMessage () {
      const firstMessage = this.beErrorGetLastMessage()
      const firstCat = this.beErrorGetLastCategory()
      if (firstMessage && firstCat === 'graphql') {
        // technical error message, do not use for customer
        return this.fallbackErrorMessage
      }
      return firstMessage
    }
  },
  computed: {
    modalCancelTitle: function () {
      return this.$slots.cancleModal?.[0]?.text
    },
    modalOkTitle: function () {
      return this.$slots.okModal?.[0]?.text
    },
    fallbackErrorMessage: function () {
      return this.getSlotText('txtToastError', 'Es ist ein technischer Fehler aufgetreten.')
    }
  },
  mixins: [

    beErrors
  ],
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
